import { Container, Grid } from "@mui/material";
import PickleballDrillDataTable from "../../components/pickleballDrill/PickleballDrillDataTable";

export default function TestPickleballDrillData() {
    return (
        <Container>
            <Grid container direction="column" gap={2}>
                <PickleballDrillDataTable />
            </Grid>
        </Container>
    );
}
